import { defineComponent as _defineComponent } from 'vue';
import AdminLayout from "@/Layouts/Admin.vue";
import { Head } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Sidebar from "primevue/sidebar";
import ModelSidebar from "@/Components/ModelSidebar.vue";
import WeatherStationDetails from "./Details.vue";
import ImportMeteoStation from "../../Orchard/WeatherStation/ImportStation.vue";
import { ref } from "vue";
import { useSpinner } from "@/Plugins/spinner";
import { useToastService } from "@/Plugins/toast-service";
import { useConfirmationService } from "@/Plugins/confirmation-service";
import WeatherStationService from "../../../Services/WeatherStationService";
import GroupActions from '../../../Components/GroupActions.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        weatherStations: {
            type: Array,
            default: [],
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const spinner = useSpinner();
        const toast = useToastService();
        const confirm = useConfirmationService();
        const weatherStationService = new WeatherStationService();
        const records = ref([]);
        const filters = ref({
            global: { value: "", matchMode: FilterMatchMode.CONTAINS },
            code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            place: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            city: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            postal_code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            state: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            country: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
        });
        const visibleRight_2 = ref(false);
        records.value = props.weatherStations;
        const formVisible = ref(false);
        const firstRecordIndex = ref(0);
        const selectedRecords = ref([]);
        const editRecordIndex = ref(null);
        const editRecordData = ref(null);
        const openForm = (data = null) => {
            editRecordData.value = data;
            formVisible.value = true;
        };
        const closeForm = (data = null) => {
            formVisible.value = false;
            if (editRecordIndex.value && data) {
                records.value[editRecordIndex.value] = data;
                toast.storeSuccess();
            }
            editRecordIndex.value = editRecordData.value = null;
        };
        const getRecordIndexById = (id) => {
            return records.value.findIndex((value) => {
                return value.id === id;
            });
        };
        const removeRecordById = (id) => {
            const recordIndex = getRecordIndexById(id);
            records.value.splice(recordIndex, 1);
        };
        const editRecord = (id) => {
            spinner.show();
            weatherStationService.show(id)
                .then((res) => openForm(res.data.data))
                .finally(() => spinner.hide());
        };
        const deleteRecord = (id) => {
            confirm.confirmDelete(() => {
                weatherStationService.delete(id).then(() => {
                    removeRecordById(id);
                    toast.deleteSuccess();
                });
            });
        };
        const deleteMultipleRecords = () => {
            confirm.confirmDeleteMultiple(selectedRecords.value.length, () => {
                spinner.show();
                weatherStationService.deleteMultiple(selectedRecords.value.map((value) => value.id))
                    .then(() => {
                    selectedRecords.value.forEach((record) => {
                        removeRecordById(record.id);
                    });
                    toast.deleteSuccess();
                })
                    .finally(() => spinner.hide());
            });
        };
        const groupActions = ref([
            {
                label: "Elimina Selezionati",
                command: deleteMultipleRecords,
            },
        ]);
        if (location.hash === '#add') {
            setTimeout(() => {
                history.replaceState(null, document.title, window.location.pathname + window.location.search);
            });
            openForm({});
        }
        const __returned__ = { spinner, toast, confirm, weatherStationService, props, records, filters, visibleRight_2, formVisible, firstRecordIndex, selectedRecords, editRecordIndex, editRecordData, openForm, closeForm, getRecordIndexById, removeRecordById, editRecord, deleteRecord, deleteMultipleRecords, groupActions, AdminLayout, get Head() { return Head; }, get InputText() { return InputText; }, get Button() { return Button; }, get DataTable() { return DataTable; }, get Column() { return Column; }, get Sidebar() { return Sidebar; }, ModelSidebar, WeatherStationDetails, ImportMeteoStation, GroupActions };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
